export default "__VITE_ASSET__746ade50__"